import { render, staticRenderFns } from "./ContractsPriceChangesRecord.vue?vue&type=template&id=1d8b6a4e&scoped=true"
import script from "./ContractsPriceChangesRecord.vue?vue&type=script&lang=js"
export * from "./ContractsPriceChangesRecord.vue?vue&type=script&lang=js"
import style0 from "./ContractsPriceChangesRecord.vue?vue&type=style&index=0&id=1d8b6a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b6a4e",
  null
  
)

export default component.exports